export interface EventIcon {
  eventType: EventType;
  iconLigature: string;
}

export enum EventType {
  VIDEOCALL = 'VIDEOCALL',
  MILESTONE = 'BOOK_MILESTONE',
  EXPERIENCE_START = 'EXPERIENCE_START',
  EXPERIENCE_END = 'EXPERIENCE_END',
  EXERCISE_START = 'EXERCISE_START',
  EXERCISE_END = 'EXERCISE_END',
  BOOK_START = 'BOOK_START',
  BOOK_END = 'BOOK_END',
}

export enum EventIconLigature {
  MILESTONE = 'milestone',
  VIDEOCAM = 'videocam',
}

export const eventIcons: EventIcon[] = [
  {
    eventType: EventType.VIDEOCALL,
    iconLigature: EventIconLigature.VIDEOCAM,
  },
  {
    eventType: EventType.MILESTONE,
    iconLigature: EventIconLigature.MILESTONE,
  },
  {
    eventType: EventType.EXPERIENCE_START,
    iconLigature: EventIconLigature.MILESTONE,
  },
  {
    eventType: EventType.EXPERIENCE_END,
    iconLigature: EventIconLigature.MILESTONE,
  },
];

export function getEventIconLigature(eventType: string) {
  const icon = eventIcons.find((eventIcon) => eventIcon.eventType === eventType);
  if (icon) {
    return icon.iconLigature;
  }

  return EventIconLigature.MILESTONE;
}
